import { Box, Typography, styled } from '@mui/material';

/**
 * Layout shared by both MFA screens — first-time enrollment and the returning-user challenge.
 * Anything specific to one flow lives in that module's own `styles.ts`.
 */

export const MfaPageContainer = styled(Box)(() => ({
  display: 'flex',
  minHeight: '100vh',
  width: '100%',
}));

/** Right-hand column, mirroring the sign-in card's position but vertically centred: no header to clear. */
export const MfaRightColumn = styled(Box)(({ theme }) => ({
  marginLeft: 'auto',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '45%',
  [theme.breakpoints.down('lg')]: {
    width: '40%',
  },
  [theme.breakpoints.down(1095)]: {
    width: '100%',
  },
}));

export const MfaCard = styled(Box)(() => ({
  padding: '0 10px',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: '16px',
  maxWidth: '340px',
  minWidth: '250px',
  width: '100%',
}));

export const MfaCardTitle = styled(Typography)(({ theme }) => ({
  color: theme.palette.secondary.contrastText,
  fontSize: '28px',
  fontWeight: 600,
  textAlign: 'center',
  [theme.breakpoints.down(1095)]: {
    fontSize: '22px',
  },
}));

export const MfaInstructions = styled(Typography)(({ theme }) => ({
  fontSize: '13px',
  textAlign: 'center',
  color: theme.palette.secondary.contrastText,
}));

export const MfaHint = styled(Typography)(({ theme }) => ({
  fontSize: '12px',
  color: theme.palette.success.main,
}));

/** Fixed height so an error appearing never shifts the buttons under the user's cursor. */
export const MfaErrorSlot = styled(Box)(({ theme }) => ({
  minHeight: '32px',
  width: '100%',
  fontSize: '14px',
  textAlign: 'center',
  color: theme.palette.error.main,
}));

export const MfaButtonRow = styled(Box)(() => ({
  display: 'flex',
  gap: '10px',
  width: '100%',
  justifyContent: 'space-between',
}));
